import React, { useState } from 'react'
import { Tabs } from '../../../components/Tabs/Tabs'
import { Tab } from 'react-bootstrap'
import { CollaborationSettings } from '../CollaborationSettings/CollaborationSettings'
import { PhoneSettings } from './PhoneSettings'
import { MFASettings } from './MFASettings'
import { useZocksAuth, useZocksQuota } from '../../../components/ScopedBlock/hooks'
import { MainComplianceSettings } from './Compliance/MainComplianceSettings'
import { AIAssistantSettings } from './AIAssistantSettings'
import { AdminAssistantSettings } from './AdminAssistantSettings'
import { EmailTypeSettings } from './EmailType/EmailTypeSettings'
import './Settings.scss'
import { AccountSettings } from './Account/AccountSettings'
import { useLocation } from 'react-router-dom'
import { LanguageSettings } from './Language/LanguageSettings'

const DEFAULT_TAB_KEY = 'account'

const getAutoNavigationParameters = (hash: string) => {
  const segments = hash.replace('#', '').split('/')
  return {
    selectedTab: segments.length > 0 && segments[0] !== '' ? segments[0] : DEFAULT_TAB_KEY,
    selectedAccordionItem: segments.length > 1 && segments[1] !== '' ? segments[1] : undefined,
  }
}

const TabTitle = ({ title }: { title: string }) => <div className='d-flex align-items-center'>{title}</div>

export const Settings = () => {
  const { hasScope } = useZocksAuth()
  const { hash } = useLocation()
  const autoNavigation = getAutoNavigationParameters(hash)
  const hasMFAAdminScope = hasScope('**', 'mfa:admin', ['mfa:admin'])

  const { hasQuota } = useZocksQuota()
  const emailEnabled = hasQuota('integration.emailEnabled.value')
  //hide under quota, TODO remove it later
  const hasMultiLanguageSupportQuota = hasQuota('ai.multiLanguageSupport.value')

  const [selectedTab, setSelectedTab] = useState(autoNavigation.selectedTab)
  const changeTab = (key: string | null) => {
    if (key) {
      setSelectedTab(key)
    }
  }

  return (
    <div className='d-flex gap-5 settings-tab-wrapper'>
      <Tabs onSelect={changeTab} defaultActiveKey={selectedTab} id='settings-tabs' className='vertical-tab'>
        <Tab className='mt-2' eventKey='account' title={<TabTitle title='Account' />}>
          <AccountSettings />
        </Tab>

        <Tab className='mt-2' eventKey='compliance' title={<TabTitle title='Compliance' />}>
          <MainComplianceSettings defaultAccordionItemKey={autoNavigation.selectedAccordionItem} />
        </Tab>

        <Tab className='mt-2' eventKey='collaboration' title={<TabTitle title='Collaboration' />}>
          <CollaborationSettings />
        </Tab>

        <Tab className='mt-2' eventKey='phone' title={<TabTitle title='Shared phone line' />}>
          <PhoneSettings />
        </Tab>
        <Tab className='mt-2' eventKey='adminAssistant' title={<TabTitle title='Admin Assistant' />}>
          <AdminAssistantSettings />
        </Tab>

        {emailEnabled ? (
          <Tab className='mt-2' eventKey='emailType' title={<TabTitle title='Email type' />}>
            <EmailTypeSettings />
          </Tab>
        ) : null}

        <Tab className='mt-2' eventKey='aiAssistant' title={<TabTitle title='AI Assistant' />}>
          <AIAssistantSettings />
        </Tab>
        {hasMFAAdminScope ? (
          <Tab className='mt-2' eventKey='mfa' title={<TabTitle title='2-factor authentication' />}>
            <MFASettings />
          </Tab>
        ) : null}
        {hasMultiLanguageSupportQuota ? (
          <Tab className='mt-2' eventKey='language' title={<TabTitle title='Language' />}>
            <LanguageSettings />
          </Tab>
        ) : null}
      </Tabs>
    </div>
  )
}
